var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"total_content"},[_c('div',{staticClass:"tool_title"},[_vm._v(_vm._s(_vm.toolTitle))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }